import ApiClient from "../ApiClient";
import NewUUID from "../../utils/randy/NewUUID";

export const getBillRules = async (billId, csrfToken) => {
    const response = await ApiClient.get(`/api/bills/templates/${billId}/rules`, {
        headers: {
            accept: "application/json",
            request_id: NewUUID(),
            "X-CSRF-Token": csrfToken
        },
    });
    return response.data.result || [];
};

export const createBillRule = async (billId, ruleData, csrfToken) => {
    const response = await ApiClient.post(`/api/bills/templates/${billId}/rules`, ruleData, {
        headers: {
            accept: "application/json",
            request_id: NewUUID(),
            "X-CSRF-Token": csrfToken
        },
    });
    return response.data.result;
};

export const updateBillRule = async (billId, ruleId, ruleData, csrfToken) => {
    const response = await ApiClient.put(`/api/bills/templates/${billId}/rules/${ruleId}`, ruleData, {
        headers: {
            accept: "application/json",
            request_id: NewUUID(),
            "X-CSRF-Token": csrfToken
        },
    });
    return response.data.result;
};

export const deleteBillRule = async (billId, ruleId, csrfToken) => {
    const response = await ApiClient.delete(`/api/bills/templates/${billId}/rules/${ruleId}`, {
        headers: {
            accept: "application/json",
            request_id: NewUUID(),
            "X-CSRF-Token": csrfToken
        },
    });
    return response.data.result;
};

export const reorderBillRules = async (billId, ruleIds, csrfToken) => {
    const response = await ApiClient.post(`/api/bills/templates/${billId}/rules/reorder`, {
        rule_ids: ruleIds
    }, {
        headers: {
            accept: "application/json",
            request_id: NewUUID(),
            "X-CSRF-Token": csrfToken
        },
    });
    return response.data.result;
};

export const calculateTestSplits = async (billId, testAmount, csrfToken) => {
    const response = await ApiClient.post(`/api/bills/templates/${billId}/rules/test-splits`, {
        test_amount: testAmount
    }, {
        headers: {
            accept: "application/json",
            request_id: NewUUID(),
            "X-CSRF-Token": csrfToken
        },
    });
    return response.data.result;
};
